"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotTestFormPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("@front/components/form-parts/events");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const defaultModelSelection = {
    model: {
        label: "Claude Sonnet 4.5",
        value: "anthropic/claude-sonnet-4.5",
    },
    cost: 0.000015
};
//@ts-ignore                
let rwsTemplate = T.html `<div class="page-wrapper">
    <div class="page-header d-print-none">
        <div class="container-xl">
            <div class="row g-2 align-items-center">
                <div class="col">                    
                    <h2 class="page-title">
                        ${x => x.isEdit ? 'botTest.edit'.t() : 'botTest.create'.t()}
                    </h2>
                </div>
                <div class="col-auto ms-auto d-print-none">
                    <div class="btn-list">
                        <button type="button" class="btn btn-outline-secondary" @click="${x => x.goBack()}">
                            <i class="simple-icon-arrow-left"></i>
                            ${() => 'form.back'.t()}
                        </button>
                        <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary" ?disabled="${x => x.loading}">
                            <i class="simple-icon-check"></i>
                            ${x => x.isEdit ? 'crud.edit'.t() : 'crud.create'.t()}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="page-body mt-3">
        <div class="container-xl">
        <the-form :onSubmit="${x => x.handleSubmit.bind(x)}">
        
        <div class="row">
            <div class="col-12">
            ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
                <div class="card">
                    <app-loader></app-loader>
                </div>
            `)}
            ${(0, fast_element_1.when)(x => !x.loading, (0, fast_element_1.html) `
                <div class="row">
                    <div class="col-12">
                        
                        <div class="card mb-4">
                            <div class="card-header">
                                <h3 class="card-title">
                                    <i class="simple-icon-note me-2"></i>
                                    ${() => 'botTest.details'.t()}
                                </h3>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="mb-3">
                                            <part-input required="true" class="form-part" label="${() => 'botTest.name'.t()}"
                                                :value="${x => x.form.name}" name="name" 
                                                placeholder="${() => 'botTest.namePlaceholder'.t()}" required="true"></part-input>
                                        </div>
                                        
                                        <div class="mb-3">
                                            <part-input required="true" class="form-part" label="${() => 'botTest.testDate'.t()}"
                                                :value="${x => x.form.testDate}" name="testDate" type="date"
                                                required="true"></part-input>
                                        </div>
                                        
                                        <div class="mb-3">
                                            <part-textarea class="form-part" label="${() => 'botTest.description'.t()}"
                                                :value="${x => x.form.description || ''}" name="description"
                                                rows="3" placeholder="${() => 'botTest.descriptionPlaceholder'.t()}"></part-textarea>
                                        </div>

                                        <div class="mb-3">
                                            <part-checkbox class="form-part" label="${() => 'botTest.active'.t()}"
                                                :value="${x => x.form.active}" name="active"></part-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        
                        <div class="card">
                            
                            <div class="card-header">
                                <ul class="nav nav-tabs card-header-tabs nav-fill" data-bs-toggle="tabs" role="tablist">
                                    ${(0, fast_element_1.repeat)(x => x.testers, (0, fast_element_1.html) `
                                        <li class="nav-item" role="presentation">
                                            <div class="nav-link ${(x, c) => c.parent.activeTab === x.id ? 'active' : ''}" 
                                               @click="${(x, c) => c.parent.switchTab(x.id || '')}" 
                                               role="tab" style="cursor: pointer;">
                                                ${(0, fast_element_1.when)((x, c) => c.parent.isTabCompleted(x.id || ''), (0, fast_element_1.html) `<i class="simple-icon-check text-success"></i>`)}
                                                ${(0, fast_element_1.when)((x, c) => !c.parent.isTabCompleted(x.id || ''), (0, fast_element_1.html) `<i class="simple-icon-chemistry"></i>`)}
                                                ${x => x.name}
                                            </div>
                                        </li>
                                    `)}
                                    
                                    <li class="nav-item" role="presentation">
                                        <div class="nav-link" @click="${x => x.addTester()}" role="tab" style="cursor: pointer;">
                                            <i class="simple-icon-plus"></i>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div class="card-body">
                                
                                ${(0, fast_element_1.repeat)(x => x.testers, (0, fast_element_1.html) `
                                    ${(0, fast_element_1.when)((x, c) => c.parent.activeTab === x.id, (0, fast_element_1.html) `
                                        <div class="d-flex justify-content-between align-items-start mb-3">
                                            <h5 class="mb-0">${x => x.name} ${() => 'botTest.configuration'.t()}</h5>
                                            ${(0, fast_element_1.when)((x, c) => c.parent.testers.length > 1, (0, fast_element_1.html) `
                                                <button type="button" class="btn btn-sm btn-outline-danger" 
                                                        @click="${(x, c) => c.parent.removeTester(x.id || '')}"
                                                        aria-label="${() => 'crud.remove'.t()}">
                                                    <i class="simple-icon-trash me-1"></i>
                                                    ${() => 'crud.delete'.t()}
                                                </button>
                                            `)}
                                        </div>
                                        
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="mb-3">
                                                    <part-input required="true" class="form-part" label="${() => 'botTest.testerName'.t()}"
                                                        :value="${x => x.name}" name="testerName"
                                                        placeholder="${() => 'botTest.testerNamePlaceholder'.t()}" required="true"></part-input>
                                                </div>
                                                
                                                <div class="mb-3">
                                                    <p><strong>${() => 'avatar.form.model.label'.t()}</strong></p>
                                                    <simple-model-select noAvatar="true" inForm="true" value="${x => { var _a; return (_a = x.model) === null || _a === void 0 ? void 0 : _a.model.value; }}"
                                                        placeholder="${() => 'avatar.form.model.placeholder'.t()}" 
                                                        :onChange="${(x, c) => c.parent.onModelSelect(x.id || '')}"
                                                        name="model">
                                                    </simple-model-select>
                                                </div>
                                                
                                                <div class="mb-3">
                                                    <part-slider class="form-part" label="${() => 'botTest.temperature'.t()}"
                                                        :value="${x => x.temperature}" name="temperature"
                                                        min="0" max="1" step="0.1" showValue="true"></part-slider>
                                                </div>
                                                
                                                <div class="mb-3">
                                                    <part-input class="form-part" label="${() => 'botTest.messagesCount'.t()}"
                                                        :value="${x => x.messagesCount}" name="messagesCount" type="number"
                                                        min="1"></part-input>
                                                </div>
                                            </div>
                                            
                                            <div class="col-lg-6">
                                                <div class="mb-3">
                                                    <part-textarea required="true" class="form-part" label="${() => 'botTest.prompt'.t()}"
                                                        :value="${x => x.prompt}" name="prompt" rows="10"
                                                        placeholder="${() => 'botTest.promptPlaceholder'.t()}" required="true"></part-textarea>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        
                                        <hr class="my-4">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="d-flex justify-content-between align-items-center mb-3">
                                                    <h4>${() => 'botTest.targets'.t()}</h4>
                                                    <button type="button" class="btn btn-sm btn-primary" @click="${(x, c) => c.parent.addTargetToTester(x.id)}">
                                                        <i class="simple-icon-plus"></i>
                                                        ${() => 'botTest.addTarget'.t()}
                                                    </button>
                                                </div>
                                                
                                                ${(0, fast_element_1.when)((x, c) => c.parent.getTargetsForTester(x.id || '').length === 0, (0, fast_element_1.html) `
                                                    <p class="text-muted text-center py-3">${() => 'botTest.noTargets'.t()}</p>
                                                `)}
                                                ${(0, fast_element_1.when)((x, c) => c.parent.getTargetsForTester(x.id || '').length > 0, (0, fast_element_1.html) `
                                                    <div class="row">
                                                        ${(0, fast_element_1.repeat)((x, c) => c.parent.getTargetsForTester(x.id || ''), (0, fast_element_1.html) `
                                                            <div class="col-md-6 col-lg-4 mb-3">
                                                                <div class="card">
                                                                    <div class="card-body">
                                                                        <div class="mb-3">
                                                                            <part-select class="form-part" label="${() => 'botTest.selectAvatar'.t()}"
                                                                                :value="${target => target.avatarId}" name="avatarId-${target => target.id}"
                                                                                :options="${target => target.avatarOptions || []}">
                                                                            </part-select>
                                                                        </div>
                                                                        
                                                                        <div class="mb-3">
                                                                            <part-switch class="form-part" label="${() => 'botTest.overrideTesterPrompt'.t()}"
                                                                                :value="${target => target.overrideTesterPrompt}"
                                                                                name="overrideTesterPrompt-${target => target.id}">
                                                                            </part-switch>
                                                                        </div>
                                                                        
                                                                ${(0, fast_element_1.when)(target => target.overrideTesterPrompt, (0, fast_element_1.html) `
                                                                    <div class="mb-3">
                                                                        <part-textarea class="form-part" label="${() => 'botTest.testerPromptOverride'.t()}"
                                                                            :value="${target => target.testerPromptOverride || ''}" name="testerPromptOverride-${target => target.id}"
                                                                            rows="2">
                                                                        </part-textarea>
                                                                    </div>
                                                                    
                                                                    <div class="mb-3">
                                                                        <part-input class="form-part" label="${() => 'botTest.messagesCount'.t()}"
                                                                            :value="${target => target.messagesCountOverride || ''}" name="messagesCountOverride-${target => target.id}" type="number" min="1">
                                                                        </part-input>
                                                                    </div>
                                                                `)}
                                                        
                                                                        <div class="mb-3">
                                                                            <part-json-editor class="form-part" label="${() => 'botTest.advancedToolsData'.t()}"
                                                                                :value="${target => target.advancedToolsData || {}}" 
                                                                                name="advancedToolsData-${target => target.id}">
                                                                            </part-json-editor>
                                                                        </div>

                                                        <button type="button" class="btn btn-sm btn-outline-danger w-100" 
                                                                @click="${target => target.removeTarget && target.removeTarget(target.id || '')}"
                                                                title="${() => 'crud.delete'.t()}">
                                                            <i class="simple-icon-trash"></i>
                                                            ${() => 'crud.delete'.t()}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        `)}
                                                    </div>
                                                `)}
                                            </div>
                                        </div>
                                    `)}
                                `)}
                            </div>
                        </div>
                        
                        
                        <div class="mt-4 text-center">
                            <button type="button" class="btn btn-outline-secondary me-2" @click="${x => x.goBack()}">
                                <i class="simple-icon-arrow-left"></i>
                                ${() => 'form.back'.t()}
                            </button>
                            <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary" ?disabled="${x => x.loading}">
                                <i class="simple-icon-check"></i>
                                ${x => x.isEdit ? 'crud.edit'.t() : 'crud.create'.t()}
                            </button>
                        </div>
                    </div>
                </div>
            `)}
            </div>
        </div>
        </the-form>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host .nav-tabs {
  border-bottom: 2px solid var(--chat_header_color);
}
:host .nav-tabs .nav-link {
  position: relative;
  border: 0;
  color: var(--text_color);
}
:host .nav-tabs .nav-link:hover {
  color: var(--primary-color);
  border: 0;
}
:host .nav-tabs .nav-link.active {
  color: var(--primary-color);
  background-color: transparent;
  border-bottom: 2px solid var(--primary-color);
}
:host .nav-tabs .nav-link i {
  margin-right: 0.5rem;
}
:host .nav-tabs .nav-link i.text-success {
  color: var(--tblr-success) !important;
}
:host .nav-tabs .nav-link .btn-close {
  padding: 0;
  font-size: 0.75rem;
  opacity: 0.5;
}
:host .nav-tabs .nav-link .btn-close:hover {
  opacity: 1;
}
:host .list-group-item {
  border-left: 0;
  border-right: 0;
}
:host .list-group-item:first-child {
  border-top: 0;
}
:host .list-group-item:last-child {
  border-bottom: 0;
}
:host .form-select-sm, :host .form-control-sm {
  font-size: 0.875rem;
}
:host .card {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}
:host .card .card-header {
  background-color: var(--tblr-bg-surface-secondary);
}`;
const shadowOptions = { "mode": "open" };
let BotTestFormPage = class BotTestFormPage extends client_1.RWSViewComponent {
    get avatarOptions() {
        return [
            { label: 'botTest.selectAvatar'.t(), value: '' },
            ...this.availableAvatars.map(avatar => {
                var _a;
                return ({
                    label: avatar.name,
                    value: ((_a = avatar.id) === null || _a === void 0 ? void 0 : _a.toString()) || ''
                });
            })
        ];
    }
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.botTestId = '';
        this.loading = false;
        this.isEdit = false;
        this.activeTab = '1';
        this.availableAvatars = [];
        // Form data
        this.form = {
            name: '',
            testDate: new Date().toISOString().split('T')[0],
            description: '',
            active: true
        };
        this.testers = [
            {
                id: '1',
                name: 'Tester 1',
                model: defaultModelSelection,
                temperature: 0.7,
                prompt: '',
                messagesCount: 10,
                order: 0
            }
        ];
        this.targets = [];
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        super.connectedCallback();
        // Get bot test ID from route parameters
        this.botTestId = this.routeParams.id;
        this.isEdit = !!this.botTestId;
        await this.loadAvatars();
        if (this.isEdit) {
            await this.loadBotTest();
        }
        // Set up form value change listener
        component_1.FormComponent.listenForValuesChange.bind(this)('form');
        // Handle specific form field changes
        this.on(events_1.inputEvents.changed, (event) => {
            const { fieldName, value } = event.detail;
            console.log('📝 [BotTest] Form field changed:', { fieldName, value });
            // Handle form field updates
            if (['name', 'testDate', 'description', 'active'].includes(fieldName)) {
                // Main form fields are automatically handled by FormComponent.listenForValuesChange
                return;
            }
            // Handle tester field updates when in a tester tab
            if (['testerName', 'temperature', 'messagesCount', 'prompt'].includes(fieldName)) {
                const mappedFieldName = fieldName === 'testerName' ? 'name' : fieldName;
                this.updateTesterField(this.activeTab, mappedFieldName, value);
                return;
            }
            // Handle target field updates (format: fieldName-targetId)
            if (fieldName.includes('-')) {
                const [field, targetId] = fieldName.split('-');
                if (['avatarId', 'overrideTesterPrompt', 'testerPromptOverride', 'messagesCountOverride', 'advancedToolsData'].includes(field)) {
                    let processedValue = value;
                    // Special processing for certain fields
                    if (field === 'messagesCountOverride') {
                        processedValue = value ? parseInt(value) || undefined : undefined;
                    }
                    this.updateTargetField(this.activeTab, targetId, field, processedValue);
                }
            }
        });
    }
    async loadAvatars() {
        try {
            const response = await this.apiService.back.get('avatar.list', { queryParams: { widget: '1' } });
            if (response.success && response.data) {
                this.availableAvatars = response.data;
                // Update existing tester targets with new avatarOptions and method bindings
                this.testers = this.testers.map(tester => ({
                    ...tester,
                    targets: (tester.targets || []).map(target => ({
                        ...target,
                        avatarOptions: this.avatarOptions,
                        removeTarget: (targetId) => this.removeTargetFromTester(tester.id, targetId),
                        updateField: (targetId, field, value) => this.updateTargetField(tester.id, targetId, field, value)
                    }))
                }));
            }
        }
        catch (e) {
            console.error('Error loading avatars:', e);
        }
    }
    async loadBotTest() {
        if (!this.botTestId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('bot-test.get', {
                routeParams: { id: this.botTestId }
            });
            if (response.success && response.data) {
                const botTest = response.data;
                this.form = {
                    name: botTest.name,
                    testDate: typeof botTest.testDate === 'string'
                        ? botTest.testDate.split('T')[0]
                        : new Date(botTest.testDate).toISOString().split('T')[0],
                    description: botTest.description || '',
                    active: botTest.active !== false
                };
                if (botTest.testers && botTest.testers.length > 0) {
                    this.testers = botTest.testers.map((tester, index) => {
                        var _a;
                        return ({
                            id: ((_a = tester.id) === null || _a === void 0 ? void 0 : _a.toString()) || `loaded-${index}`,
                            name: tester.name,
                            model: tester.model,
                            temperature: tester.temperature,
                            prompt: tester.prompt,
                            messagesCount: tester.messagesCount,
                            order: tester.order || index,
                            targets: (tester.targets || []).map((target, targetIndex) => {
                                var _a, _b, _c;
                                return ({
                                    id: ((_a = target.id) === null || _a === void 0 ? void 0 : _a.toString()) || `loaded-target-${targetIndex}`,
                                    avatarId: ((_c = (_b = target.avatar) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.toString()) || '',
                                    avatar: target.avatar,
                                    overrideTesterPrompt: target.overrideTesterPrompt || false,
                                    testerPromptOverride: target.testerPromptOverride || '',
                                    messagesCountOverride: target.messagesCountOverride,
                                    advancedToolsData: target.advancedToolsData,
                                    order: target.order || targetIndex,
                                    avatarOptions: this.avatarOptions,
                                    removeTarget: (targetId) => { var _a; return this.removeTargetFromTester(((_a = tester.id) === null || _a === void 0 ? void 0 : _a.toString()) || `loaded-${index}`, targetId); },
                                    updateField: (targetId, field, value) => { var _a; return this.updateTargetField(((_a = tester.id) === null || _a === void 0 ? void 0 : _a.toString()) || `loaded-${index}`, targetId, field, value); }
                                });
                            })
                        });
                    });
                    // Activate the first tester tab
                    this.activeTab = this.testers[0].id || '1';
                }
            }
            else {
                this.notifyService.notify(response.error || 'botTest.loadFailed'.t(), 'error');
            }
        }
        catch (e) {
            console.error('Error loading bot test:', e);
            this.notifyService.notify('botTest.loadFailed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    switchTab(tabName) {
        this.activeTab = tabName;
    }
    addTester() {
        const newTester = {
            id: Date.now().toString(),
            name: `Tester ${this.testers.length + 1}`,
            model: defaultModelSelection,
            temperature: 0.7,
            prompt: '',
            messagesCount: 10,
            order: this.testers.length,
            targets: []
        };
        this.testers = [...this.testers, newTester];
        this.activeTab = newTester.id;
    }
    removeTester(testerId) {
        if (this.testers.length === 1) {
            this.notifyService.notify('botTest.minimumOneTester'.t(), 'warning');
            return;
        }
        // Find the index of the tester being removed
        const currentIndex = this.testers.findIndex(t => t.id === testerId);
        this.testers = this.testers.filter(t => t.id !== testerId);
        // Remove all targets associated with this tester
        this.targets = this.targets.filter(target => target.testerId !== testerId);
        // Switch to previous tab if we removed the active one
        if (this.activeTab === testerId && this.testers.length > 0) {
            // If there was a previous tester, switch to it
            if (currentIndex > 0) {
                this.activeTab = this.testers[currentIndex - 1].id || '1';
            }
            else {
                // If it was the first tab, switch to the new first tab
                this.activeTab = this.testers[0].id || '1';
            }
        }
    }
    addTargetToTester(testerId) {
        var _a;
        if (this.availableAvatars.length === 0) {
            this.notifyService.notify('botTest.noAvatarsAvailable'.t(), 'warning');
            return;
        }
        const tester = this.testers.find(t => t.id === testerId);
        if (!tester) {
            this.notifyService.notify('botTest.testerNotFound'.t(), 'error');
            return;
        }
        const newTarget = {
            id: Date.now().toString(),
            avatarId: '',
            overrideTesterPrompt: false,
            testerPromptOverride: '',
            messagesCountOverride: undefined,
            advancedToolsData: undefined,
            order: ((_a = tester.targets) === null || _a === void 0 ? void 0 : _a.length) || 0,
            avatarOptions: this.avatarOptions,
            removeTarget: (targetId) => this.removeTargetFromTester(testerId, targetId),
            updateField: (targetId, field, value) => this.updateTargetField(testerId, targetId, field, value)
        };
        if (!tester.targets) {
            tester.targets = [];
        }
        tester.targets.push(newTarget);
        // Trigger reactivity
        this.testers = [...this.testers];
    }
    removeTargetFromTester(testerId, targetId) {
        const tester = this.testers.find(t => t.id === testerId);
        if (tester && tester.targets) {
            tester.targets = tester.targets.filter(t => t.id !== targetId);
            // Trigger reactivity
            this.testers = [...this.testers];
        }
    }
    updateTesterField(testerId, field, value) {
        this.testers = this.testers.map(tester => tester.id === testerId ? { ...tester, [field]: value } : tester);
        // Trigger reactivity
        this.testers = [...this.testers];
    }
    getTargetsForTester(testerId) {
        const tester = this.testers.find(t => t.id === testerId);
        return (tester === null || tester === void 0 ? void 0 : tester.targets) || [];
    }
    updateTargetField(testerId, targetId, field, value) {
        console.log('🎯 [BotTest] updateTargetField:', { testerId, targetId, field, value });
        const tester = this.testers.find(t => t.id === testerId);
        if (tester && tester.targets) {
            tester.targets = tester.targets.map(target => {
                if (target.id === targetId) {
                    const updated = {
                        ...target,
                        [field]: value,
                        // Preserve bound methods
                        avatarOptions: target.avatarOptions || this.avatarOptions,
                        removeTarget: target.removeTarget || ((id) => this.removeTargetFromTester(testerId, id)),
                        updateField: target.updateField || ((id, f, v) => this.updateTargetField(testerId, id, f, v))
                    };
                    // If avatarId changed, update avatar reference
                    if (field === 'avatarId') {
                        updated.avatar = this.availableAvatars.find(a => { var _a; return ((_a = a.id) === null || _a === void 0 ? void 0 : _a.toString()) === value; });
                        console.log('🎯 [BotTest] Avatar updated for target:', { testerId, targetId, avatarId: value, avatar: updated.avatar });
                    }
                    return updated;
                }
                return target;
            });
            // Trigger reactivity
            this.testers = [...this.testers];
        }
        console.log('🎯 [BotTest] Updated testers with targets:', this.testers);
    }
    onModelSelect(testerId) {
        return (selected) => {
            console.log('🤖 [BotTest] Model selected for tester:', { testerId, selected });
            this.updateTesterField(testerId, 'model', selected);
        };
    }
    async handleSubmit(event) {
        if (event && typeof event.preventDefault === 'function') {
            event.preventDefault();
        }
        await this.save();
    }
    async save() {
        var _a;
        if (!this.validateForm()) {
            return;
        }
        this.loading = true;
        try {
            console.log('💾 [BotTest] Preparing to save form data:', {
                form: this.form,
                testers: this.testers
            });
            const payload = {
                name: this.form.name,
                testDate: this.form.testDate,
                description: this.form.description,
                active: this.form.active,
                testers: this.testers.map((tester, index) => ({
                    name: tester.name,
                    model: tester.model,
                    temperature: tester.temperature,
                    prompt: tester.prompt,
                    messagesCount: tester.messagesCount,
                    order: index,
                    targets: (tester.targets || []).map((target, targetIndex) => {
                        let advancedToolsData = undefined;
                        if (target.advancedToolsData) {
                            advancedToolsData = target.advancedToolsData;
                        }
                        const targetPayload = {
                            avatarId: target.avatarId || null,
                            overrideTesterPrompt: target.overrideTesterPrompt,
                            testerPromptOverride: target.testerPromptOverride,
                            messagesCountOverride: target.messagesCountOverride,
                            advancedToolsData,
                            order: targetIndex
                        };
                        console.log('🎯 [BotTest] Target payload:', { original: target, payload: targetPayload });
                        return targetPayload;
                    })
                }))
            };
            console.log('💾 [BotTest] Final payload to send:', payload);
            let response;
            if (this.isEdit) {
                response = await this.apiService.back.put('bot-test.update', payload, {
                    routeParams: { id: this.botTestId }
                });
            }
            else {
                response = await this.apiService.back.post('bot-test.create', payload);
            }
            console.log('📡 [BotTest] API Response:', response);
            if (response.success) {
                console.log('✅ [BotTest] Save successful:', response.data);
                this.notifyService.notify(this.isEdit ? 'botTest.updated'.t() : 'botTest.created'.t(), 'info');
                // Redirect to preview page with the bot test ID
                const botTestId = this.isEdit ? this.botTestId : (_a = response.data) === null || _a === void 0 ? void 0 : _a.id;
                if (botTestId) {
                    component_2.SiteMenu.goto.bind(this)(`/bot-test/preview/${botTestId}`);
                }
                else {
                    // Fallback to list if ID is not available
                    component_2.SiteMenu.goto.bind(this)('/bot-test/list');
                }
            }
            else {
                console.error('❌ [BotTest] Save failed:', response.error);
                this.notifyService.notify(response.error || 'botTest.saveFailed'.t(), 'error');
            }
        }
        catch (e) {
            console.error('Error saving bot test:', e);
            this.notifyService.notify('botTest.saveFailed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    resetForm() {
        this.form = {
            name: '',
            testDate: new Date().toISOString().split('T')[0],
            description: '',
            active: true
        };
        this.testers = [
            {
                id: '1',
                name: 'Tester 1',
                model: defaultModelSelection,
                temperature: 0.7,
                prompt: '',
                messagesCount: 10,
                order: 0
            }
        ];
        this.targets = [];
        // Reset form parts using FormComponent method
        const formElement = this.$('the-form');
        if (formElement && typeof formElement.reset === 'function') {
            formElement.reset();
        }
    }
    validateForm() {
        if (!this.form.name.trim()) {
            this.notifyService.notify('botTest.nameRequired'.t(), 'error');
            return false;
        }
        if (!this.form.testDate) {
            this.notifyService.notify('botTest.testDateRequired'.t(), 'error');
            return false;
        }
        if (this.testers.length === 0) {
            this.notifyService.notify('botTest.minimumOneTester'.t(), 'error');
            return false;
        }
        for (const tester of this.testers) {
            if (!tester.name.trim()) {
                this.notifyService.notify('botTest.testerNameRequired'.t(), 'error');
                return false;
            }
            if (!tester.prompt.trim()) {
                this.notifyService.notify('botTest.testerPromptRequired'.t(), 'error');
                return false;
            }
        }
        for (const target of this.targets) {
            if (!target.avatarId) {
                this.notifyService.notify('botTest.targetAvatarRequired'.t(), 'error');
                return false;
            }
        }
        return true;
    }
    goBack() {
        component_2.SiteMenu.goto.bind(this)('/bot-test/list');
    }
    isTabCompleted(testerId) {
        const tester = this.testers.find(t => t.id === testerId);
        return !!(tester && tester.name.trim() && tester.prompt.trim());
    }
};
exports.BotTestFormPage = BotTestFormPage;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], BotTestFormPage.prototype, "botTestId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], BotTestFormPage.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], BotTestFormPage.prototype, "isEdit", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], BotTestFormPage.prototype, "activeTab", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], BotTestFormPage.prototype, "availableAvatars", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], BotTestFormPage.prototype, "form", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], BotTestFormPage.prototype, "testers", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], BotTestFormPage.prototype, "targets", void 0);
exports.BotTestFormPage = BotTestFormPage = __decorate([
    (0, client_1.RWSView)('bot-test-form', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], BotTestFormPage);
BotTestFormPage.defineComponent();
